<template>
<div>
    <AppSummary
        :title_summary="titleSummary"
        title_collapse="Calcular frete"
        :collapses="collapses"
    >
        <template #total-estimate-collapse>
            <LoadingApp
                :isLoading.sync="isLoading"
                :is_full_page="true"
            />
            <div class="form-group form-group-sm" style="display: flex;align-items: center;">
                <input
                    type="text"
                    v-model="cepdestino"
                    v-mask="'#####-###'"
                    class="form-control form-control-sm"
                    placeholder="CEP"
                    style="width: 50%;height: 3.8rem;"
                    @keypress.enter="shippingCalculate()"
                />
                <c-button
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    margin="0px 0rem 0px 5px"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    height="3.8rem"
                    minWidth="unset"
                    padding="1rem 2rem"
                    display="flex"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing="unset"
                    transition="all .3s"
                    justifyContent="center"
                    @click.prevent.stop="shippingCalculate()"
                >
                    <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">Calcular</span>
                </c-button>
            </div>
            <!-- href="http://www.buscacep.correios.com.br/sistemas/buscacep/"  -->
            <a style="cursor:pointer;" @click="$root.showModalApp('modal_cep')" >
                <small  >Não sei meu cep</small>
            </a>
            <div v-if="cepVazio" class="required">Digite um cep</div>
            <div v-if="getBiggerAvailabilityInCart != 0">
                <small>Item com prazo para disponibilidade no carrinho: <strong>+{{ getBiggerAvailabilityInCart > 1 ? getBiggerAvailabilityInCart+" dias" : getBiggerAvailabilityInCart+ "dia"}}</strong> para entrega. </small>
            </div>
            <clip-loader
                :loading="loadingCalculate"
                :color="$colorLoading"
            >
            </clip-loader>
            <template v-if="cepdestino && shippingMethods && !loadingCalculate">
                <table >
                <tbody>
                    <tr
                        v-for="(shipping, key) in shippingMethods"
                        :key="key"
                        class="form-group"
                    >
                        <template v-if="shipping.error === '0'">
                            <td style="vertical-align: top;">
                                <input
                                type="radio"
                                :value="shipping"
                                @change="setShippingMethod(shipping)"
                                :id="'shipping_correios'+key+1"
                                :checked="setChecked(shipping)"
                                style="margin-top:2px; margin-right: 5px;"
                            >
                            </td>
                            <!-- v-model="metodoenvio" -->
                            <label :for="'shipping_correios'+key+1">
                                <td style="width:165px">
                                    <c-span>
                                        {{ shipping.type  }}
                                    </c-span>
                                    <br>
                                <p v-if="shipping.description"
                                >
                                    {{ shipping.description  }}
                                </p>
                                </td>
                                <td style="width:80px;vertical-align: top;">
                                    <c-span>
                                        {{ prazoEntrega(shipping.prazoEntrega) }}
                                    </c-span>
                                </td>
                                <td style="vertical-align: top;">
                                    <c-span>
                                        <b>{{ +shipping.price > 0 && shipping.type != 'RETIRAR NA LOJA' ? currency.money(shipping.price) : null }}</b>
                                    </c-span>
                                </td>
                            </label>
                        </template>
                    </tr>
                </tbody>
            </table>
            </template>
            <template v-if="cepdestino && shippings.frenet && !loadingCalculate">
                <table >
                    <tbody>
                        <tr
                            v-for="(shipping, key) in shippings.frenet"
                            :key="key"
                            class="form-group"
                        >
                            <template v-if="shipping.Error == false">
                                <td >
                                    <input
                                    type="radio"
                                    :value="shipping"
                                    name="shipping_frenet"
                                    @change="setShippingMethod(shipping)"
                                    :id="'shipping_frenet'+key+1"
                                    :checked="setChecked(shipping)"
                                    style="margin-bottom:6px; margin-right: 5px;"
                                >
                                </td>
                                <!-- v-model="metodoenvio" -->
                                <label :for="'shipping_frenet'+key+1">
                                    <td style="width:165px">
                                        <c-span>
                                            {{ shipping.ServiceDescription  }}
                                        </c-span>
                                    </td>
                                    <td style="width:80px">
                                        <c-span>
                                            {{ prazoEntrega(shipping.DeliveryTime) }}
                                        </c-span>
                                    </td>
                                    <td >
                                        <c-span>
                                            <b>{{ shipping.ShippingPrice > 0 ? currency.money(shipping.ShippingPrice) : null }}</b>
                                        </c-span>
                                    </td>
                                </label>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </template>

            <!-- Fretes alemaonzinho -->
            <template v-if="cepdestino && shippings.alemaonzinho && !loadingCalculate">
                <div
                    v-for="(shipping, key) in shippings.alemaonzinho"
                    :key="shipping.id"
                    class="form-group"
                >
                    <template v-if="shipping.error === '0'">
                        <input
                            type="radio"
                            :value="shipping"
                            @change="setShippingMethod(shipping)"
                            @click.stop="$root.showModalApp('modal_message_alemaozinho')"
                            :id="'shipping_alemaonzinho'+key+1"
                            :checked="setChecked(shipping)"
                        >
                            <!-- v-model="metodoenvio" -->
                        <label :for="'shipping_alemaonzinho'+key+1">
                            {{shipping.price}}
                            {{ (Number(shipping.price) > 0 || shipping.type != "RETIRAR NA LOJA") ? currency.money(shipping.price) : null }}
                            {{ prazoEntrega(shipping.prazoEntrega) }}
                            {{ shipping.type  }}
                            <a :href="$baseUrl+'page/frete'" target="_blanck">
                                <small>Consultar regulamento</small>
                            </a>
                        </label>
                    </template>
                </div>
            </template>
        </template>
        <template v-slot:footer>
            <table class="table table-totals">
                <tbody v-if="hasDiscounts || shippingSummary">
                    <tr>
                        <td>Valor bruto</td>

                        <td>{{ currency.money(itemsCart.subTotal)}}</td>
                    </tr>
                    <tr v-if="hasDiscounts">
                        <td>
                            <button
                                type="button"
                                style="border: 0; background: transparent; padding: 0; font: inherit; cursor: pointer;"
                                @click.prevent="toggleDiscounts"
                            >
                                Descontos
                                <i :class="['fas', discountsExpanded ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                            </button>
                        </td>
                        <td>{{currency.money(totalDiscountAmount)}}</td>
                    </tr>
                    <template v-if="hasDiscounts && discountsExpanded">
                        <tr v-for="discount in discountBreakdown" :key="discount.label">
                            <td style="font-size: 1.2rem; padding-top: 0; padding-bottom: 0;">
                                {{ discount.label }}
                            </td>
                            <td style="font-size: 1.2rem; padding-top: 0; padding-bottom: 0;">
                                -{{ currency.money(discount.amount) }}
                            </td>
                        </tr>
                    </template>
                    <tr v-if="shippingSummary">
                        <td>Frete</td>
                        <td>{{ shippingSummary }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>Total líquido</td>
                        <td>
                            {{ currency.money(itemsCart.totalAmount)}}
                            <template v-if="show_ipi && !calculateIpi">
                                + IPI
                            </template>
                        </td>
                    </tr>
                    <template v-if="itemsCart.list[0].minimum_purchase_amount_supplier > 0 || itemsCart.list[0].minimum_purchase_amount_supplier != null">
                        <tr>
                            <td style="font-size:1.2rem; padding: 0;">Fornecedor:</td>
                            <td style="font-size:1.2rem; padding: 0;"><strong>{{itemsCart.list[0].supplier_name}}</strong></td>
                        </tr>
                        <tr>
                            <td style="font-size:1.2rem; padding: 0;">Pedido Mínimo:</td>
                            <td style="font-size:1.2rem; padding: 0;"> <strong> R$ {{itemsCart.list[0].minimum_purchase_amount_supplier}}</strong> </td>
                        </tr>
                        <tr>
                            <td style="font-size:1.2rem; padding: 0;">ICMS PR:</td>
                            <td style="font-size:1.2rem; padding: 0;"> <strong> {{itemsCart.list[0].icms_credit_pr}} %</strong> </td>
                        </tr>
                        <tr>
                            <td style="font-size:1.2rem; padding: 0;">ICMS SC:</td>
                            <td style="font-size:1.2rem; padding: 0;"> <strong> {{itemsCart.list[0].icms_credit}} %</strong> </td>
                        </tr>
                        <tr>
                            <td style="font-size:1.2rem; padding: 0;">ICMS RS:</td>
                            <td style="font-size:1.2rem; padding: 0;"> <strong> {{itemsCart.list[0].icms_credit_rs}} %</strong> </td>
                        </tr>
                        <tr v-if="itemsCart.list[0].shipping_rule_supplier != null">
                            <td style="font-size:1.2rem; padding: 0;">FRETE:</td>
                            <td style="font-size:1.2rem; padding: 0;"> <strong> {{itemsCart.list[0].shipping_rule_supplier}}</strong> </td>
                        </tr>
                        <template v-if="itemsCart.list[0].payment_name != null">
                            <tr v-for="payment in itemsCart.list[0].payment_name.split(',')">
                            <td style="font-size:1.2rem; padding: 0;">PRAZO DE PAGAMENTO:</td>
                            <td style="font-size:1.2rem; padding: 0;"> <strong> {{payment}}</strong> </td>
                        </tr>
                        </template>

                    </template>
                </tfoot>
            </table>
            <div class="checkout-methods">
                <CartDiscount v-if="active_discount_coupon == true"/>
                <c-button-checkout
                    class="btn-block"
                    @click.prevent="checkout()"
                    v-html="contentButtonCheckout"
                ></c-button-checkout>
                 <SearchPostalCode
                    @searchedCep="searchedCep"
                />
            </div>
        </template>
    </AppSummary>
</div>
</template>

<script>
import AppSummary from '../AppSummary.vue'
import Currency from '../../helpers/parseCurrency'
import { mapState, mapActions, mapGetters } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import LoadingApp from '../LoadingApp'
import CartDiscount from '../../components/cart/CartDiscount'
import {CAncora, CButtonCheckout} from '../../components/Styles/Button/styled'
import { CButton } from '../Styles/Button/styled';
import SearchPostalCode from '../SearchPostalCode.vue'
import ConsultaCep from '../../api/consultaCep'
import { swall } from '../../services/sweetAlert'
import { CSpan } from '../Styles/Components/styled'

export default {
    name:'CartSummary',
    components: {
        'clip-loader':ClipLoader,
        AppSummary,
        LoadingApp,
        CartDiscount,
        SearchPostalCode,
        'c-ancora': CAncora,
        'c-button': CButton,
        'c-button-checkout': CButtonCheckout,
        'c-span': CSpan,
    },
    props: {
        cepdestination:{default:null}
    },
    data() {
        return {
            isLoading: false,
            coupon_code: '',
            currency: Currency,
            cepdestino: null,
            metodoenvio: null,
            cepVazio:false,
            shippingMethods:[],
            active_discount_coupon: this.$root.$children[0].$attrs.company?.settings?.active_discount_coupon ?? true,
            discountsExpanded: false,
            collapses: [
                {
                    title: "Calcular frete",
                    id: "total-estimate-collapse",
                    collapsed: true
                },
            ]
        }
    },
    async created() {
        await this.ActionGetShippingMethod()
        this.cepdestino = this.cepdestination;
        if (this.cepdestino && this.shippingMethod) {
            this.shippingCalculate();
        }
    },
    methods: {
        ...mapActions("cart", [
            "ActionGetItemsCart",
            "ActionSetItemsCart",
            "ActionApplyDiscount",
        ]),
        ...mapActions("shipping", [
            "ActionSetShippings",
            "ActionShippingCalculate",
            "ActionSetShippingMethod",
            "ActionGetShippingMethod"
        ]),
        checkout() {
            if (Number(this.itemsCart.list[0].minimum_purchase_amount_supplier) > 0 && Number(this.itemsCart.totalAmount) < Number(this.itemsCart.list[0].minimum_purchase_amount_supplier)) {
                swall(`O valor mínimo de compra do fornecedor ${this.itemsCart.list[0].supplier_name} é de ${this.currency.money(this.itemsCart.list[0].minimum_purchase_amount_supplier)}. \nAumente o valor do pedido ou entre em contato conosco!`, true);
                return
            }
            if(this.client?.maximum_purchase_amount && this.client.maximum_purchase_amount > 0 && Number(this.itemsCart.totalAmount) > Number(this.client.maximum_purchase_amount)) {
                swall(`O seu valor máximo de compra é de ${this.currency.money(this.client.maximum_purchase_amount)}. \nReduza o valor do pedido ou entre em contato conosco!`, true);
                return
            }
            if(this.minimumPurchaseAmount && this.minimumPurchaseAmount > 0 && Number(this.itemsCart.totalAmount) < Number(this.minimumPurchaseAmount)) {
                swall(`Para avançar com o seu pedido, é necessário uma compra mínima de ${this.currency.money(this.minimumPurchaseAmount)}. \nConvidamos você a explorar mais as nossas novidades, produtos e condições imperdíveis.`, true);
                return
            }
            window.location.href = this.$baseUrl+'checkout'
        },
        subTotal(total) {
            if(!this.metodoenvio) {
                return this.currency.money(total)
            }
            if(this.metodoenvio.price && this.metodoenvio.price > 0) {
                return this.currency.money(total - this.metodoenvio.price)
            }
            return this.currency.money(total)
        },
        async consultaCep(cep_consulta) {
            if(!cep_consulta) {
                return false
            }
            try {
                let {
                    erro=null,
                    localidade=null,
                    uf=null

                } = await ConsultaCep.get(cep_consulta)
                if(erro) {
                    swall("CEP inválido!", true)
                    return false
                }
                // if(uf && localidade) {
                //     this.localDestino = localidade+' - '+uf.toUpperCase()
                // }
            } catch(error) {
                swall(error?.msg ?? error?.message ?? error, true);
                return false
            }
            return true
        },
        async shippingCalculate() {
            this.cepVazio = false
            if(!this.cepdestino) {
                this.cepVazio = true
                return
            }
            try {
                this.shippingMethods = []
                const cepIsValid = await this.consultaCep(this.cepdestino)
                if(!cepIsValid) {
                    return;
                }

                await this.ActionShippingCalculate({cepDestination: this.cepdestino})
                // this.metodoenvio = null
                let arr = [
                    ...this.shippings.correio,
                    ...this.shippings.rodonaves,
                    ...this.shippings.fflip_fretes??[],
                    ...this.shippings.melhor_envio,
                    ...this.shippings.jamef,
                    ...this.shippings.jadlog,
                    ...this.shippings.ac_express,
                    ...this.shippings.aceville,
                    ...this.shippings.braspress,
                    ...this.shippings.bauer,
                    ...this.shippings.expresso_sao_miguel,
                    ...this.shippings.zanotelli,
                    ...this.shippings.tnt,
                    ...this.shippings.todo_brasil,
                    ...this.shippings.transp_aceville,
                    ...this.shippings.azurelog,
                    ...this.shippings.ebtrans,
                    ...this.shippings.rodovitor,
                    ...this.shippings.agex,
                    ...this.shippings.farias_faz,
                    ...this.shippings.sc_logistica,
                    ...this.shippings.alfa,
                    ...this.shippings.ativa,
                    ...this.shippings.total_express
                ]
                arr.map( el => (!this.shippingMethods.filter(v => v.type === el.type).length) && this.shippingMethods.push(el))
                // o servidor so mantem o frete escolhido se ele voltou igual na cotacao nova
                await this.ActionGetShippingMethod().catch(() => {})
            } catch(error) {
                swall(error?.msg ?? error?.message ?? error, true);
            }
        },
        async setShippingMethod(val) {
            try {
                if(val?.Msg == "") {
                    val.Msg = null
                }
                await this.ActionSetShippingMethod({shippingMethod: val})
            } catch(error) {
                swall(error?.msg ?? error?.message ?? error, true);
                if(error?.quoteExpired) {
                    this.shippingCalculate()
                }
            }
        },
        prazoEntrega(prazo) {
            if(prazo === null) {
                return
            }
            prazo = +prazo + this.getBiggerAvailabilityInCart;
            if(prazo > 1) {
                return prazo+' dias'
            }
            return prazo+' dia'
        },
        searchedCep(cep){
           this.cepdestino = cep
           this.shippingCalculate()
        },
        toggleDiscounts() {
            this.discountsExpanded = !this.discountsExpanded
        },
        setChecked(s) {
            if (!this.shippingMethod) {
                return false;
            }
            if(this.shippingMethod.ServiceCode) {
                return (
                s.id == this.shippingMethod.ServiceCode &&
                s.prazoEntrega == this.shippingMethod.OriginalDeliveryTime &&
                s.price == this.shippingMethod.ShippingPrice &&
                s.rule_id == this.shippingMethod.CarrierCode &&
                s.shipping_company_id == this.shippingMethod.ServiceCode &&
                s.type == this.shippingMethod.ServiceDescription
                )
            }
            else return (
                s.correio == this.shippingMethod.correio &&
                s.id == this.shippingMethod.id &&
                s.prazoEntrega == this.shippingMethod.prazoEntrega &&
                s.price == this.shippingMethod.price &&
                s.rule_id == this.shippingMethod.rule_id &&
                s.shipping_company_id == this.shippingMethod.shipping_company_id &&
                s.type == this.shippingMethod.type
            )
        },
        async resetShippingMethod() {
            this.isLoading = true;
            await this.setShippingMethod(null);
            await this.getItemsCart();
            this.ActionSetShippings({});
            this.shippingMethods = [];
            this.isLoading = false;
        },
        getItemsCart() {
            this.ActionGetItemsCart()
            .then((resp) => {
                let { data } = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                if(error.msg) {
                    console.log('ERROR GET ITEMS CART: '+error.msg)
                    return
                }
                console.log('ERROR GET ITEMS CART: '+error)
            })
        },
    },
    watch: {
        shippingMethod(val) {
            this.metodoenvio = val
        },
        quoteSignature(val, oldVal) {
            if (!oldVal || val === oldVal || !this.cepdestino || !this.shippingMethods.length) {
                return;
            }
            this.shippingCalculate();
        },
        cepdestino(cep, oldCep) {
            if (!oldCep || oldCep.replace('-', '') == cep.replace('-', '') || cep.length < 9) {
                return;
            }
            this.resetShippingMethod();
        }
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ]),
        ...mapState("clients", [
            "client"
        ]),
        ...mapState("shipping", [
            "shippings",
            "loadingCalculate",
            "shippingMethod"
        ]),
        ...mapState('company',[
            'facebookPixel'
        ]),
        ...mapGetters("cart", [
            "quoteSignature"
        ]),
        show_ipi() {
            return ((this.$root.$children[0].$attrs.company?.products_settings?.show_ipi ?? false) && this.itemsCart.list.some(el => el.ipi_percentage))
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        titleSummary() {
            return this.isBudgetLayout ? 'Resumo do orçamento' : 'Resumo do pedido'
        },
        contentButtonCheckout() {
            return this.$root.$children[0].theme?.button_checkout?.content ?? "Checkout"
        },
        calculateIpi() {
            return this.$root.$children[0].$attrs.company?.settings?.calculate_ipi ?? false
        },
        // So o frete que o cliente escolheu e que tem valor (ja somado no total) ou
        // retirada/frete gratis. Sem frete escolhido ou com R$ 0,00 a linha dava a
        // entender que o frete era gratis.
        shippingSummary() {
            const price = Number(this.metodoenvio?.price || this.metodoenvio?.ShippingPrice || 0)
            if (price > 0) {
                return this.currency.money(price)
            }
            if (this.metodoenvio?.type === 'RETIRAR NA LOJA' || this.metodoenvio?.type === 'FRETE GRÁTIS') {
                return this.metodoenvio.type
            }
            return null
        },
        minimumPurchaseAmount() {
            return this.$root.$children[0].$attrs.company?.settings?.minimum_purchase_amount ?? 0
        },
        discountBreakdown() {
            const discounts = [...(this.itemsCart?.discountBreakdown ?? [])]
            if (this.hasShippingDiscount) {
                discounts.push({
                    label: 'Frete',
                    amount: this.itemsCart.shippingDiscountAmount
                })
            }
            return discounts
        },
        totalDiscountAmount() {
            return Number(this.itemsCart?.discountAmount ?? 0) + Number(this.itemsCart?.shippingDiscountAmount ?? 0)
        },
        hasDiscounts() {
            return this.totalDiscountAmount > 0
        },
        hasShippingDiscount() {
            return Number(this.itemsCart?.shippingDiscountAmount ?? 0) > 0
        },

        getBiggerAvailabilityInCart() {
            let biggerAvailability = 0
            this.itemsCart.list.forEach(i => {
                if (i.availability  >  biggerAvailability ) {
                    biggerAvailability = i.availability
                }
            });

            return +biggerAvailability
        }

    }
}
</script>
